<script lang="ts">
    import { z } from 'zod';
    import * as echarts from 'echarts';

    import WidgetTemplateInner from '../../../../shared/Dashboard/WidgetTemplateInner.svelte';
    import {
        type DashboardComponentType,
        WidgetManager,
    } from '../../../../shared/Dashboard/WidgetManager';
    import { ChartDailyPeopleDataConverter } from './ChartDailyPeopleDataConverter';
    import { DataSchema, type DataType } from './types';

    export let dashboardItem: DashboardComponentType;
    export let widgetManager: WidgetManager;

    export const defaultChartOption: echarts.EChartsOption = {
        grid: {
            containLabel: true,
            left: '10%',
            right: '10%',
            top: 0,
            bottom: 0,
        },
        yAxis: [
            {
                inverse: true,
                data: [],
                // type: 'bar',
                // data: [
                //     'outside_legend',
                //     'outside_legend',
                //     'outside_legend',
                //     'outside_legend',
                //     'outside_legend',
                //     'outside_legend',
                //     'outside_legend',
                // ],
                type: 'category',
                // axisLabel: {
                //     color: '#fff'
                // },
                position: 'left',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
            },
            {
                // type: 'bar',
                inverse: true,
                data: [],
                // data: [
                //     'inside_chart',
                //     'inside_chart',
                //     'inside_chart',
                //     'inside_chart',
                //     'inside_chart',
                //     'inside_chart',
                //     'inside_chart',
                // ],
                position: 'left',
                axisLabel: {
                    inside: true,
                    color: '#000',
                    interval: 0  // Show every label
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: false,
                },
                z: 20,
            },
        ],
        xAxis: {
            type: 'value',
            axisLabel: {
                rotate: 45,
                formatter: function (value, index): string {
                    if (index % 2 === 0) {
                        return value.toString(); // Display label only at even indices
                    } else {
                        return ''; // Hide label at odd indices
                    }
                },
            },
        },
        series: [
            {
                data: [],
                // data: [
                //     120,
                //     {
                //         value: 200,
                //         itemStyle: {
                //             color: '#a90000',
                //         },
                //     },
                //     150,
                //     80,
                //     70,
                //     110,
                //     130,
                // ],
                type: 'bar',
                showBackground: true,
            },
        ],
    };

    dashboardItem.we.setChartOption(defaultChartOption);
    dashboardItem.we.setDataSchema(DataSchema);
    dashboardItem.we.setUpdateFunction((defaultChartOption, data: DataType) => {
        return ChartDailyPeopleDataConverter.convertAPIFormatToChartData<DataType>(
            data,
            defaultChartOption,
            { primary: '#000000', secondary: '#000000' }
        );
    });
</script>

<WidgetTemplateInner bind:widgetManager {dashboardItem} />
